import { default as ProductCheckoutPage } from './product-checkout';
import { default as ProductCartPage } from './product-cart';
import { default as ProductDetailsPage } from './product-details';
import { default as ProductSupplierPage } from './product-supplier';
import { default as ProductProceedPage } from './product-proceed';
import { default as ProductCatalogPage } from './product-catalog';

export default {
  ProductCartPage,
  ProductCheckoutPage,
  ProductDetailsPage,
  ProductSupplierPage,
  ProductProceedPage,
  ProductCatalogPage
}
